import styled from "styled-components";
import { SectionWrapper } from "shared/Styles/Wrappers";

export const Container = styled.div`
  padding: 124px 0;
  background-color: ${({ color }) => (color ? color : "#fff")};
  color: ${({ color }) => (color ? "#fff" : "#000")};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    padding: 64px 0;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 36px 0;
  }
`;

export const Wrapper = styled(SectionWrapper)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const Item = styled.div`
  width: calc(50% - 12px);
  margin-bottom: 24px;
  &:not(:nth-child(2n)) {
    margin-right: 24px;
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tablet_big}) {
    width: calc(50% - 6px);
    margin-bottom: 12px;
    &:not(:nth-child(2n)) {
      margin-right: 12px;
    }
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tablet_big}) {
    width: 100%;
    margin-right: 0 !important;
  }
`;
